export const communitysetupDetailsData = [
    { 
        title: 'Create Channels', 
        content: 'Set up channels to organize community conversations, make specific spaces for different groups, and sort resources for easy access.',
    },
];
